export const CAST_INFO_EMAIL = 'info@cast-soft.com';

export const CAST_NOREPLY_EMAIL = 'noreply@castgroupinc.com';

export const CAST_TECH_SUPPORT_EMAIL = 'techsupport@castgroupinc.com';

export const CAST_SALES_ADMIN_EMAIL = 'salesadmin@castgroupinc.com';

export const CAST_SALES_EMAIL = 'sales@castgroupinc.com';
